/**
 * Auth API surface (F0). Mirrors PRD §7 auth endpoints.
 * OAuth start returns a provider redirect URL; magic-link requests an email.
 */

import { http } from '@/shared/api/http';

export type OAuthProvider = 'google' | 'microsoft' | 'github';

export interface AuthUser {
  id: string;
  email: string;
  oauth_provider: string | null;
}

/** A hydrated session: the raw JWT plus the resolved user profile. */
export interface TokenResponse {
  token: string;
  user: AuthUser;
}

interface OAuthStartResponse {
  redirect_url: string;
}

interface MagicLinkResponse {
  sent: boolean;
}

export const authApi = {
  /** Begin an OAuth flow — backend returns the provider authorize URL. */
  startOAuth(provider: OAuthProvider): Promise<OAuthStartResponse> {
    return http.post<OAuthStartResponse>(`/auth/oauth/${provider}`, {
      anonymous: true,
    });
  },

  /** Request a magic-link email for passwordless sign-in. */
  requestMagicLink(email: string): Promise<MagicLinkResponse> {
    return http.post<MagicLinkResponse>('/auth/magic-link', {
      anonymous: true,
      json: { email },
    });
  },

  /** Fetch the current authenticated user (JWT required). */
  me(): Promise<AuthUser> {
    return http.get<AuthUser>('/me');
  },
};
